import React from "react";
import Scrollbar from "components/basic/scrollbar";

export interface ScrollContainerProps {
  height?: number | string;
  children: React.ReactElement<HTMLDivElement>;
  showHint?: boolean;
  hintScrollToBottomOnClick?: boolean;
  sx?: React.CSSProperties;
}

const ScrollContainer: React.FC<ScrollContainerProps> = ({
  height = "100%",
  children,
  showHint = true,
  hintScrollToBottomOnClick = true,
  sx = {},
}) => {
  return (
    <Scrollbar
      showHint={showHint}
      hintScrollToBottomOnClick={hintScrollToBottomOnClick}
      sx={{
        height,
        ...sx,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          minHeight: "100%",
        }}
      >
        {children}
      </div>
    </Scrollbar>
  );
};

export default ScrollContainer;
